import React from 'react';

export default () => (
  <p>
    <strong>Flo's Whistle: Pandemic</strong> is a{' '}
    <a href="https://codefordayton.org/" target="_blank" rel="noopener noreferrer">
      Code for Dayton
    </a>{' '}
    project. We're an independent collaboration of volunteer developers, nurses, physicians,
    attorneys, writters, designers, and journalists from the Code for America Brigade community.
    ©2020
  </p>
);
